import { isHighEntropyLabel } from '../../shared/highentropy';
import { escapeHtml } from './dom';
import { loadDeviceHistory } from '../storage/persistence';

export interface Animal { key: string; name: string; short: string; img: string }

export const ANIMALS: Animal[] = [
  { key:'bear',   name:'Bear',   short:'bea', img:'/animals/bear.png' },
  { key:'fox',    name:'Fox',    short:'fox', img:'/animals/fox.png' },
  { key:'owl',    name:'Owl',    short:'owl', img:'/animals/owl.png' },
  { key:'rabbit', name:'Hare',   short:'har', img:'/animals/rabbit.png' },
  { key:'mouse',  name:'Mouse',  short:'mou', img:'/animals/mouse.png' },
  { key:'frog',   name:'Frog',   short:'frg', img:'/animals/frog.png' },
];
export const byKey: Record<string, Animal> = Object.fromEntries(ANIMALS.map(a=>[a.key,a]));
export const byShort: Record<string, string> = Object.fromEntries(ANIMALS.map(a=>[a.short,a.key]));

export const ANIMAL_KEYS = new Set(ANIMALS.map(a => a.key));
export function isHighEntropyDevice(animals: string[] | null | undefined): boolean {
  return isHighEntropyLabel(animals as string[], ANIMAL_KEYS);
}
// Avatar group for a device's label (or group) segments, given its colour.
export function segAvatarsHtml(segments: string[] | null | undefined, color: string): string {
  const segs = Array.isArray(segments) ? segments : [];
  if(isHighEntropyDevice(segs)){
    return `<span class="he-swatch" style="background:${color}" aria-hidden="true"></span>`;
  }
  return segs.map(k => `<img src="${byKey[k]?.img || ''}" alt=""/>`).join('');
}
// A device's display name: the server-set DISPLAY TAG (ADR 0022) wins — it is
// the owner's chosen, shared name — then a local-history nickname, then animal
// names; a high-entropy device with none shows "Private · <tail>" rather than
// its random segments. Returns HTML-safe text (the tag is attacker-controllable
// free text echoed to other viewers, so it is ALWAYS escaped here — never
// interpolate a raw tag into innerHTML).
export function deviceDisplayName(token: string, animals: string[] | null | undefined, group: string[] | null | undefined, history?: any[], tag?: string | null): string {
  if(tag) return escapeHtml(tag);
  // F3: a loop caller can pass an already-parsed history array to avoid one
  // localStorage JSON.parse per row; standalone callers omit it and we parse.
  const entry = (history ?? loadDeviceHistory()).find((d: any) => d.token === token);
  if(entry?.name) return escapeHtml(entry.name);
  const a = Array.isArray(animals) ? animals : [];
  // Empty/unknown label (e.g. a high-entropy token that doesn't decode to
  // animals) or a non-animal label → the "Private" fallback.
  if(a.length === 0 || isHighEntropyDevice(a)){
    return 'Private · ' + escapeHtml(token.split('-').slice(-1)[0]);
  }
  const g = (group && group.length === 2) ? group.map((k: string) => byKey[k]?.name || k).join(' · ') + ' / ' : '';
  return g + a.map((k: string) => byKey[k]?.name || k).join(' · ');
}
